const Loading = () => {
    return (
      <div className="loader-container w-100 row mx-auto mx-md-0 p-5">
        <div className="loader ">Loading...</div>
      </div>
    );
}

export default Loading;